export const sanitizeMetadataValue = (value: string) => {
  // Remove control characters and non-ASCII characters
  return value.replace(/[^\x20-\x7E]+/g, "");
};

export const inferMimeType = (file: File): string => {
  const fileExtension = file.name.split(".").pop();
  switch (fileExtension) {
    case "pdf":
      return "application/pdf";
    case "docx":
      return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case "doc":
      return "application/msword";
    case "txt":
      return "text/plain";
    case "xls":
      return "application/vnd.ms-excel";
    case "xlsx":
      return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case "xlsm":
      return "application/vnd.ms-excel.sheet.macroEnabled.12";
    default:
      return "application/octet-stream";
  }
};